// extracted by mini-css-extract-plugin
export default {"yes":"notifications-card-yes-HbAZvh","no":"notifications-card-no-EhpiKq"};